import React, { useEffect, useRef, useState } from 'react';
import { Check } from 'lucide-react';

export const Expertise = ({ data }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="expertise-section">
      <div className="container">
        <div className="expertise-content">
          <div className="expertise-left">
            <h2 className={`section-title ${isVisible ? 'fade-in-up' : ''}`}>
              {data.title}
            </h2>
            <p className={`expertise-description ${isVisible ? 'fade-in-up delay-1' : ''}`}>
              {data.description}
            </p>
          </div>
          <div className="expertise-right">
            <ul className="expertise-features">
              {data.features.map((feature, index) => (
                <li
                  key={index}
                  className={`expertise-feature ${isVisible ? 'fade-in-left' : ''}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <Check size={24} className="feature-icon" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};